import React from 'react';
import PackageSelection from '../components/PackageSelection';
import EmployerPackagePurchase from '../components/EmployerPackagePurchase';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const PackagesPage = ({ user, userData }) => {
  const navigate = useNavigate();

  // Determine which component to show based on user type
  const isEmployer = userData?.userType === 'employer';
  const isJobSeeker = userData?.userType === 'jobseeker';

  // Called when a jobseeker successfully purchases a subscription
  const handleSubscriptionUpdate = () => {
    // Redirect to dashboard after successful subscription purchase via hard reload
    window.location.href = '/dashboard';
  };

  // Called when an employer successfully purchases a package
  const handleEmployerPurchaseSuccess = (purchasedInfo) => {
    const isDatabasePkg = purchasedInfo?.type === 'database' || purchasedInfo?.packageName?.toLowerCase().includes('database');
    window.location.href = isDatabasePkg ? '/database' : '/dashboard/employer';
  };

  if (!userData?.userType) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <div className="text-center p-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading packages...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        {isEmployer && (
          <EmployerPackagePurchase
            user={user}
            userData={userData}
            showCurrentPackage={true}
            onPurchaseSuccess={handleEmployerPurchaseSuccess}
          />
        )}

        {isJobSeeker && (
          <>
            {/* Info banner for jobseekers coming from profile save */}
            <div className="max-w-6xl mx-auto px-4 pt-8">
              <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-6 mb-6 text-white shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold mb-1">🎉 Profile Saved Successfully!</h2>
                    <p className="text-indigo-100 text-sm">
                      तुमचे profile save झाले! आता एक subscription plan निवडा आणि job applications सुरू करा.
                      <br />
                      <span className="text-white font-medium">Subscribe करा → Dashboard access मिळवा</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <PackageSelection
              user={user}
              userData={userData}
              onSubscriptionUpdate={handleSubscriptionUpdate}
            />
          </>
        )}

        {!isEmployer && !isJobSeeker && (
          <div className="max-w-4xl mx-auto px-4 py-16 text-center">
            <div className="bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Invalid User Type</h2>
              <p className="text-gray-600 mb-6">
                Your account type is not recognized. Please contact support.
              </p>
              <p className="text-sm text-gray-500">
                User Type: <span className="font-mono bg-gray-100 px-2 py-1 rounded">{userData?.userType || 'undefined'}</span>
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default PackagesPage;
